import React from 'react';
import { Upload, UploadProps, Button } from 'antd';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import { CustomComponentProps } from '../types';

const { Dragger } = Upload;

/**
 * Custom Upload wrapper component
 */
export interface MyUploadProps extends CustomComponentProps {
  uploadProps?: UploadProps;
  uploadType?: 'button' | 'dragger' | 'avatar';
  listType?: 'text' | 'picture' | 'picture-card' | 'picture-circle';
  maxCount?: number;
  accept?: string;
  multiple?: boolean;
  buttonText?: string;
  draggerText?: string;
  draggerHint?: string;
}

const MyUpload: React.FC<MyUploadProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  uploadType = 'button',
  listType = 'text',
  maxCount,
  accept,
  multiple = false,
  buttonText = 'ატვირთვა',
  draggerText = 'დააჭირეთ ან გადაიტანეთ ფაილი აქ',
  draggerHint = 'მხარს უჭერს ცალკე ან მრავლობითი ფაილის ატვირთვას',
  uploadProps,
  ...rest
}) => {
  const handleChange = (info: any) => {
    if (onChange) {
      onChange(info.fileList);
    }
  };

  const commonProps: UploadProps = {
    fileList: value,
    onChange: handleChange,
    disabled: disabled || readonly,
    listType,
    maxCount,
    accept,
    multiple,
    beforeUpload: () => false, // Prevent auto upload
    ...uploadProps,
  };

  if (uploadType === 'dragger') {
    return (
      <Dragger {...commonProps} {...rest}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{draggerText}</p>
        <p className="ant-upload-hint">{draggerHint}</p>
      </Dragger>
    );
  }

  if (uploadType === 'avatar' || listType === 'picture-card') {
    return (
      <Upload {...commonProps} {...rest}>
        {(!value || value.length === 0 || (maxCount && value.length < maxCount)) && (
          <Button icon={<UploadOutlined />} disabled={disabled || readonly}>
            {buttonText}
          </Button>
        )}
      </Upload>
    );
  }

  return (
    <Upload {...commonProps} {...rest}>
      <Button icon={<UploadOutlined />} disabled={disabled || readonly}>
        {buttonText}
      </Button>
    </Upload>
  );
};

export default MyUpload;
